<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form
        ref="elementForm"
        @submit="addElement"
        :validation-schema="elementSchema"
      >
        <div
          class="tab-pane fade show active p-10"
          id="home-tab-pane"
          role="tabpanel"
          tabindex="0"
        >
          <div class="row">
            <div class="col-md-3">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Date
                </label>
                <Field
                  name="dateReglement"
                  type="date"
                  
                  v-model="dateReglement"
                  class="form-control shadow-none fs-md-15 text-black"
                />
                <ErrorMessage name="dateReglement" class="text-danger" />
              </div>
            </div>
            <div class="col-md-9">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Agent <span class="text-danger">*</span>
                </label>
                <Field name="utilisateur" v-model="agentSelected" v-slot="{ field }">
                  <Multiselect
                    v-model="field.value"
                    v-bind="field"
                    :options="agentOptions"
                    :searchable="true"
                    @change="agentChange($event)"
                    placeholder="Rechercher un element"
                    noResultText="Aucun enregistrement trouvé"
                    noOptionsText="Tapez au moins deux caractères"
                  />
                </Field>
                <ErrorMessage name="agent" class="text-danger" />
              </div>
            </div>

            <div class="col-md-12">
              <div class="card" style="padding: 0px !important">
                <div
                  class="card-header d-flex justify-content-between align-items-center"
                  style="background-color: #0098c7 !important;color: white;"
                >
                  <input style="width: 200px !important;"
                    type="text"
                    v-model="searchQuery"
                    placeholder="Rechercher..."
                    class="form-control pt-6 pb-6 ps-25 pe-25 pt-md-5 pb-md-5 ps-md-20 pe-md-20 rounded-1 fs-md-15 fs-lg-16"
                  />
                  <h5 class="card-title mb-0">Lignes des reglements</h5>
                  <h5 class="card-title mb-0">Total : {{ montantTotal }} Fcfa</h5>
                  <!-- <button
                    type="button"
                    class="default-btn transition border-0 fw-medium text-white pt-6 pb-6 ps-25 pe-25 pt-md-5 pb-md-5 ps-md-20 pe-md-20 rounded-1 fs-md-15 fs-lg-16"
                    @click="addReglement"
                  >
                    + ajouter une ligne
                  </button> -->
                </div>
                <div class="card-body">
                  <table class="table" style="width: 100% !important">
                    <thead style="width: 100% !important">
                      <th style="min-width: 300px !important">Client</th>
                      <th>Montant du</th>
                      <th>Montant payer</th>
                      <th>montant restant du</th>
                      <th></th>
                    </thead>
                    <tbody>
                      <tr v-for="(reg, index) in filteredReglements" :key="index">
                        <td style="margin-bottom: 5px !important">
                          
                          <Field
                            :name="'reg_vente' + index"
                            v-slot="{ field }"
                            v-model="reg.vente"
                          >
                            <Multiselect
                              :options="clientOptions"
                              v-model="field.value"
                              :searchable="true"
                              track-by="label"
                              label="label"
                              v-bind="field"
                              placeholder="Sélectionnez le client"
                              :disabled="!!reg.vente"
                            />
                          </Field>
                          <ErrorMessage
                            :name="'reg_vente' + index"
                            class="text-danger"
                          />
                        </td>

                        <td>
                          <Field
                            :name="'reg_montantDu' + index"
                            type="text"
                            v-model="reg.montantDu"
                            class="form-control shadow-none fs-md-15 text-black"
                            placeholder="0"
                            :disabled="!!reg.vente"
                          />
                          <ErrorMessage
                            :name="'reg_montantDu' + index"
                            class="text-danger"
                          />
                        </td>

                        <td>
                          <Field
                            :name="'reg_montant' + index"
                            type="text"
                            v-model="reg.montant"
                            class="form-control shadow-none fs-md-15 text-black"
                            placeholder="0"
                            @keypress="isNumber($event)"
                            @input="(reg.montant > reg.montantDu) ? reg.montant = reg.montantDu : ''"
                          />
                          <ErrorMessage
                            :name="'reg_montant' + index"
                            class="text-danger"
                          />
                        </td>

                        <td>
                          <Field
                            :name="'reg_restAPayer' + index"
                            type="text"
                            v-model="reg.restAPayer"
                            class="form-control shadow-none fs-md-15 text-black"
                            placeholder="0"
                            :disabled="!!reg.vente"
                          />
                          <ErrorMessage
                            :name="'reg_restAPayer' + index"
                            class="text-danger"
                          />
                        </td>

                        <td>
                          <button
                            type="button"
                            class="btn btn-sm btn-outline-danger"
                            @click="removeLigne(index)"
                          >
                            x
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div style="clear: both"></div>
            <br />

            <div class="col-md-3 d-none">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                  Total <span class="text-danger">*</span>
                  </label>
                  <Field name="montantTotal" type="text" v-model="montantTotal"
                  class="form-control shadow-none fs-md-15 text-black" placeholder="0"/>
                  <ErrorMessage name="montantTotal" class="text-danger"/>
              </div>
            </div>
            <div class="col-md-3">
              <!-- <div class="form-group mb-15 mb-sm-20 mb-md-25">
                                <label class="d-block text-black fw-semibold mb-10">
                                Mise <span class="text-danger">*</span>
                                </label>
                                <Field name="mise" type="text" v-model="montantMise" 
                                class="form-control shadow-none fs-md-15 text-black" readonly placeholder="0"/>
                                <ErrorMessage name="mise" class="text-danger"/>
                            </div> -->
            </div>
            <div class="col-md-3">
              <!--   <div class="form-group mb-15 mb-sm-20 mb-md-25">
                                <label class="d-block text-black fw-semibold mb-10">
                                Montant / 20 <span class="text-danger">*</span>
                                </label>
                                <Field name="mt20" type="text" v-model="mt20"
                                class="form-control shadow-none fs-md-15 text-black" readonly placeholder="0"/>
                                <ErrorMessage name="mt20" class="text-danger"/>
                            </div> -->
            </div>
            <div class="col-md-3">
              <!-- <div class="form-group mb-15 mb-sm-20 mb-md-25">
                                <label class="d-block text-black fw-semibold mb-10">
                                Montant total <span class="text-danger">*</span> ( {{ total }} )
                                </label>
                                <Field name="montant" type="text" v-model="montantTotal"
                                class="form-control shadow-none fs-md-15 text-black" readonly placeholder="0"/>
                                <ErrorMessage name="montant" class="text-danger"/>
                            </div> -->
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="d-flex align-items-center">
              <!-- <button
                class="default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                type="submit"
              >
                Enregistrer
              </button> -->
              <button
                  class="default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                  type="submit"
                  :disabled="isSubmitting"
              >
                  <span v-if="isSubmitting" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  <span v-else>Enregistrer</span>
              </button>
              <router-link
                to="/Reglements-groupe"
                class="btn btn-danger transition border-0 lh-1 fw-medium"
                ><i
                  class="flaticon-delete lh-1 me-1 position-relative top-2"
                ></i>
                <span class="position-relative"></span>Annuler
              </router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch, onMounted, reactive, nextTick, computed } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import ApiService from "../../services/ApiService";
import * as Yup from "yup";
import { Reglement } from "../../models/Reglement";
import { Vente } from "../../models/Vente";
import { error, success, hideModal, isNumber } from "../../utils/utils";
import Multiselect from "@vueform/multiselect";
import router from "@/router";

export default defineComponent({
  name: "AddReglementGroupe",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect,
  },
  props: {
    item: {
      type: Number,
      default: 0,
    },
  },
  setup(props, { emit }) {
    const elementSchema = Yup.object().shape({
      utilisateur: Yup.string().required("L'agent est obligatoire"),
      dateReglement: Yup.string().required("La date est obligatoire"),
      // montantTotal: Yup.number().required("Le montant total est obligatoire").min(0, "Le montant total doit être supérieur ou égal à 0"),
    });

    const elementForm = ref<Reglement | null>(null);
    const agentSelected = ref(null);
    const clientSelected = ref(null);
    const clientOptions = ref([]);
    const agentOptions = ref([]);
    const isUPDATE = ref(false);
    const dateReglement = ref<string | null>(null);
    const montantTotal = ref(0.0);
    const searchQuery = ref('');
    const isSubmitting = ref(false);

    

    const reglements = reactive([
      {
        client: '',
        vente: '',
        dateReglement: null,
        montantDu: '',
        montant: '',
        restAPayer: '',
      },
    ]);


    // const reglements = reactive<any[]>([]);

    const addReglement = () => {
      reglements.push({
        client: '',
        vente: '',
        dateReglement: null,
        montantDu: '',
        montant: '',
        restAPayer: '',
      });
    };

    // watch(() => agentSelected, (newValue) => {
    //   console.log("agentSelected", newValue);
    //   // appel des vente non regler concernant ce agent
    //   fetchClient();
    // });

    const agentChange = (val) => {
      agentSelected.value = val;
      console.log("agentSelected", agentSelected.value);
      // appel des vente non regler concernant ce agent
      fetchClient( agentSelected.value );
    };

    // const getFilteredOptions = (index) => {
    //     const selectedOptions = reglements.map(c => c.vente?.split('-')[0]);
    //     console.log("eeee", selectedOptions);
    //     return clientOptions.value.filter((option: any) => {
    //         console.log("aaaa",reglements[index].vente);
    //         option = option.value.split('-')[0];
    //         return !selectedOptions.includes(option) || (reglements[index].vente && option === reglements[index].vente.split('-')[0]);
    //     })
    // };


    watch(() => reglements.map((rg, index) => ({vente: rg.vente, index})), (newValue) => {
      newValue.forEach(({ vente, index }) => {
        if(reglements[index].vente && reglements[index].vente != ''){
          // console.log('deschanel',reglements[index]);
            let montantDu : any = reglements[index].vente;
            montantDu  = parseInt( montantDu.split("-")[1]) - parseInt( montantDu.split("-")[2]);
            reglements[index].montantDu = montantDu;
        }
      });
      // updateTotal();
    });

    

    watch(() => reglements.map((rg, index) => ({montant: rg.montant, index})), (newValue) => {
        newValue.forEach(({ montant, index }) => {
            if(reglements[index].montant){
              // console.log('deschanel',reglements[index]);
                let mt : any = reglements[index].montant;
                console.log('mt', mt);
                let mtRDU  = reglements[index].montantDu !== null ? parseInt(reglements[index].montantDu) - parseInt(mt) : 0;
                reglements[index].restAPayer = mtRDU.toString();
                // console.log('mes valeurs', reglements[index].montant, reglements[index].montantDu);
                if(parseInt(reglements[index].montant) > parseInt(reglements[index].montantDu.toString())){
                  reglements[index].montant = reglements[index].montantDu.toString();
                  // console.log("upodate");
                }
            }
        });
        updateTotal();
    },{ deep: true }
  );



    const produitsError = ref(false);

    //   const getVenteData = async (val) => {
    //     const vente : any = venteOptions__.value.filter((p : any) => {
    //       return p.id == val;
    //     });
    //     console.log('yes', vente[0].mise);
    //     montantAPayer.value = vente[0].mise;
    //     restAPayer.value = parseFloat(vente[0].montant) - parseFloat(vente[0].totalPayer);
    //   }

    const getCurrentDate = () => {
      const today = new Date();
      const day = String(today.getDate()).padStart(2, "0");
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const year = today.getFullYear();
      console.log(`yes ${year}-${month}-${day}`);
      return `${year}-${month}-${day}`;
    };

    const fetchClient = async (val) => {
      ApiService.get("/ventes/nonregler/agent/"+val)
        .then(({ data }) => {
          clientOptions.value = data.data.map((c) => {
            return {
              value: c.id+'-'+(parseFloat(c.montant))+'-'+c.totalPayer,
              label: "[ " +c.client.code +" ] " +c.client.nom +" " +c.client.prenoms +" - " +c.montant +" F CFA",
            };
          });

          // reglements.splice(0, reglements.length);
          clientOptions.value.forEach( async (client : any, index: number) => {
            console.log('client', client.value);
              
              await reglements.push({
                client: client.label,
                vente: client.value,
                dateReglement: null,
                montantDu: '',
                montant: '',
                restAPayer: '',
              });
            
          });
          setTimeout(() => {
            removeLigne(0);
          }, 10);
          
          console.log('reglements', reglements);
          
        })
        .catch(({ response }) => {
          // produitsError.value = true;
        });
    };

    const fetchAgent = async () => {
      ApiService.get("/utilisateurs/agent")
        .then(({ data }) => {
          agentOptions.value = data.data.map((p) => {
            return {
              value: p.id,
              label: p.nom + " " + p.prenoms,
            };
          });
        })
        .catch(({ response }) => {
          // produitsError.value = true;
        });
    };

    const removeLigne = (index) => {
      reglements.splice(index, 1);
    };

    const getOne = async (id: number) => {
      return ApiService.get("/reglement/" + id)
        .then(({ data }) => {
          // map data in form
          const donnees = data.data;
          for (const key in donnees) {
            elementForm.value?.setFieldValue(
              key,
              typeof donnees[key] === "object" && donnees[key] !== null
                ? donnees[key].id
                : donnees[key]
            );
          }
          //   emit('openmodal', addElementModalRef.value);
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    };

    // const updateTotal = () => {
    //     montantTotal.value = reglements.reduce((acc, p) => {
    //         return acc + parseFloat( p.montant.toString());
    //     }, 0);
    // };

    const updateTotal = () => {
      montantTotal.value = reglements.reduce((acc, p) => {
        const montant = p.montant !== null && !isNaN(parseFloat( p.montant.toString())) ?
         parseFloat(p.montant.toString()) : 0;
        return acc + montant;
      }, 0);
    };

    const addElement = async (values: any, elementForm) => {
      isSubmitting.value = true;

      // Supprimer dynamiquement tous les champs lié
      Object.keys(values).forEach((key) => {
        if (key.startsWith("reg_")) {
          delete values[key];
        }
      });

      values.reglements = reglements.map((re) => ({
        client: null,
        vente: re.vente,
        dateReglement: dateReglement.value,
        montant: re.montant,
        restAPayer: re.restAPayer,
      }));

      console.log('valeur a send',values);
      values = values as Reglement;
      if (isUPDATE.value) {
        ApiService.put("/reglement/" + values.id, values)
          .then(({ data }) => {
            if (data.code == 200) {
              success(data.message);
              elementForm.resetForm();
              isUPDATE.value = false;
              emit("close");
            }
          })
          .catch(({ response }) => {
            error(response.data.message);
          });
      } else {
        console.log("values", values);
        ApiService.post("/reglementGroupe", values)
        .then(async ({ data }) => {
          if (data.code == 201) {
            success(data.message);
            elementForm.resetForm();
            router.push('/Reglements-groupe');
          }
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
      }
    };

    const filteredReglements = computed(() => {
      return reglements.filter(reg => {
        return reg.client.toLowerCase().includes(searchQuery.value.toLowerCase());
      });
    });

    onMounted(() => {
      fetchAgent();
      dateReglement.value = getCurrentDate();
    });

    //   const resetValue = () => {
    //     const formFields = document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input, textarea');
    //       isUPDATE.value=false;
    //     formFields.forEach(field => {
    //       field.value = '';
    //     });
    //     btnTitle();
    //   };

    return {
      elementSchema,
      addElement,
      getCurrentDate,
      elementForm,
      agentSelected,
      clientSelected,
      agentOptions,
      clientOptions,
      reglements,
      addReglement,
      removeLigne,
      dateReglement,
      agentChange,
      montantTotal,
      updateTotal,
      searchQuery,
      filteredReglements,
      isNumber,
      isSubmitting
      // getFilteredOptions
    };
  },
});
</script>

<style scoped>
tbody tr td {
  padding-left: 0px !important;
}
</style>
